import { FC, useMemo } from 'react'
import { Box } from '@mui/material'
import { ImageOverlay } from 'react-leaflet'
import { IHeatmap } from '../../../../shared/types/api/heatmap.type'
import { latLngBounds, LatLngBounds } from 'leaflet'

interface IProps {
  heatmap?: IHeatmap | null
}

const HeatmapComponent: FC<IProps> = ({ heatmap }) => {
  const heatmapBounds = useMemo<LatLngBounds | null>(
    () =>
      heatmap?.bounds
        ? latLngBounds([heatmap.bounds[0], heatmap.bounds[1]], [heatmap.bounds[2], heatmap.bounds[3]])
        : null,
    [heatmap],
  )

  return (
    <Box>
      {heatmap && heatmap.png_mercator && heatmapBounds && (
        <ImageOverlay url={`data:image/png;base64,${heatmap.png_mercator}`} bounds={heatmapBounds} />
      )}
    </Box>
  )
}

export default HeatmapComponent
